export default __webpack_public_path__ + "assets/icons/received.4edf043a.svg";